import { combineEpics } from 'redux-observable'

import { handleMouseEvents } from './mouse'
import { handleKeyboardEvents, handleAlwaysOnModifierDownEvents,
  handleAlwaysOnModifierUpEvents, handleActiveModifierDownEvents,
  handleActiveModifierUpEvents } from './keyboard'

export const keyboardMouseEpic = combineEpics(
  handleAlwaysOnModifierDownEvents,
  handleActiveModifierDownEvents,
  handleKeyboardEvents,
  handleMouseEvents,
  handleActiveModifierUpEvents,
  handleAlwaysOnModifierUpEvents
)
